import './Legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <span className="mono legal-tag">PuzzleForge</span>
          <h1 className="mono">Terms &amp; Conditions</h1>
          <p className="legal-date mono">Last updated: March 24, 2026</p>
        </div>

        <div className="legal-body">

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using PuzzleForge ("the Service") at puzzleforge.io, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the Service.</p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>PuzzleForge is an AI-powered daily puzzle platform offering word, geography, math, trivia, and logic puzzles. The Service is available in free and premium tiers.</p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>You must provide a valid email address to create an account. You are responsible for maintaining the confidentiality of your password and for all activity under your account. You must be at least 13 years old to use the Service.</p>
          </section>

          <section>
            <h2>4. Subscriptions and Payments</h2>
            <p>Premium subscriptions are billed monthly at $4.99 USD. Payments are processed by Paddle.com, our Merchant of Record. By subscribing, you authorize recurring charges until you cancel. All sales are final unless otherwise required by law. You may cancel at any time from your account settings, effective at the end of the current billing period.</p>
          </section>

          <section>
            <h2>5. Refund Policy</h2>
            <p>All subscription purchases are final and non-refundable. You may cancel anytime; cancellation takes effect at end of the billing period.</p>
          </section>

          <section>
            <h2>6. Intellectual Property</h2>
            <p>All content on PuzzleForge, including puzzles, branding, and software, is the property of PuzzleForge and protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without written permission.</p>
          </section>

          <section>
            <h2>7. Prohibited Conduct</h2>
            <p>You agree not to: use automated tools to scrape or extract puzzle content; attempt to reverse-engineer the Service; share account credentials; or use the Service for any unlawful purpose.</p>
          </section>

          <section>
            <h2>8. Disclaimer of Warranties</h2>
            <p>The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted access or that the Service will be error-free.</p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, PuzzleForge shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>
          </section>

          <section>
            <h2>10. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the new Terms.</p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:support@puzzleforge.io">support@puzzleforge.io</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
